import React from 'react'
import { CirclePlusIcon } from '@fluentui/react-icons-mdl2'
import { useGeneralContext } from 'contexts/GeneralContext'

import useRouter from 'hooks/useRouter'

import styles from './CloseButton.module.css'

type CloseButtonProps = {
  color?: string
}

const CloseButton: React.FC<CloseButtonProps> = ({ color = '#fff' }) => {
  const router = useRouter()
  const { closeToPath, setCloseToPath, setSearchAutoFocus } =
    useGeneralContext()

  const onClose = () => {
    if (closeToPath) {
      router.push(closeToPath)
    } else {
      router.push('/')
    }
    setSearchAutoFocus(false)
    setCloseToPath(null)
  }

  return (
    <div
      className={styles.button}
      onClick={onClose}
      role="button"
      tabIndex={0}
      style={{ color }}
    >
      <CirclePlusIcon />
    </div>
  )
}

export default CloseButton
